/**
 * @generated SignedSource<<b1c45c22d10b0284ab08e4993ec4e564>>
 * @relayHash 96610985969285162c5eaf685fec1e1f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID bd20d1d516a79ca40d1ce4b3f36e37a5ee68821f3246b9b27a148b769a8103e6

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { FieldsPageViewQuery } from './FieldsPageViewQuery.graphql';

const node: PreloadableConcreteRequest<FieldsPageViewQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "bd20d1d516a79ca40d1ce4b3f36e37a5ee68821f3246b9b27a148b769a8103e6",
    "metadata": {},
    "name": "FieldsPageViewQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
